import { createFileRoute } from '@tanstack/react-router';

import { LandingNext } from '#features/landing/components/LandingNext';

export const Route = createFileRoute('/{-$locale}/_layout/preview/landing-next')({
  staticData: { rendersOwnFooter: true },
  component: LandingNextPreview,
  ssr: false,
});

function LandingNextPreview() {
  const { locale } = Route.useParams();
  return <LandingNext language={locale === 'ru' ? 'ru' : 'en'} />;
}
